import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthSelector } from "../redux/selector/auth";

const ProtectRoute = ({ children }) => {
  const authData = useAuthSelector();
  const { isLoggedIn } = authData;

  return isLoggedIn ? children : <Navigate to="/" />;
};

export default ProtectRoute;
